import { createAsyncThunk } from "@reduxjs/toolkit";
import { postRequest, getRequest } from "Utilities/ApiHelpers/ApiHelpers.index";
import { multitenantRoutes } from "Constants/api";
import {
  ICreateTenantLicenseRequest,
  ICreateTenantLicenseResponse,
  ILicenseTierOption,
  IPackageInfo,
  ILicenseSettingInfo,
  ISupportedFileFormatsResponse,
} from "./types";
import { ServiceType } from "Config/types";

export const createTenantLicense = createAsyncThunk(
  "licenseManagement/createTenantLicense",
  async (
    request: ICreateTenantLicenseRequest
  ): Promise<ICreateTenantLicenseResponse> => {
    const url = `${multitenantRoutes.createTenantLicense}`;
    const response = await postRequest(url, null, true, request, null);
    return response.data;
  }
);

export const getLicenseTiers = createAsyncThunk(
  "licenseManagement/getLicenseTiers",
  async (): Promise<ILicenseTierOption[]> => {
    const url = `${multitenantRoutes.getLicenseTiers}`;
    const response = await getRequest(url, null, true, ServiceType.Landlord);
    return response.data;
  }
);

export const getPackageNames = createAsyncThunk(
  "licenseManagement/getPackageNames",
  async (): Promise<IPackageInfo[]> => {
    const url = `${multitenantRoutes.getPackageNames}`;
    const response = await getRequest(url, null, true, ServiceType.Landlord);
    return response.data;
  }
);

export const getLicenseSettings = createAsyncThunk(
  "licenseManagement/getLicenseSettings",
  async (): Promise<ILicenseSettingInfo[]> => {
    const url = `${multitenantRoutes.getLicenseSettings}`;
    const response = await getRequest(url, null, true, ServiceType.Landlord);
    return response.data;
  }
);

export const getSupportedFileFormats = createAsyncThunk(
  "licenseManagement/getSupportedFileFormats",
  async (): Promise<ISupportedFileFormatsResponse> => {
    const url = `${multitenantRoutes.getSupportedFileFormats}`;
    const response = await getRequest(url, null, true, ServiceType.Landlord);
    return response.data;
  }
);
